/**
 * This code was generated by Builder.io.
 */
import React from "react";
import styles from "./Footer.module.css";

function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerContent}>
        <div className={styles.aboutSection}>
          <h3 className={styles.aboutTitle}>
            More about Ukay-Ukay Online Shope
          </h3>
          <p className={styles.aboutText}>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Enim sint
            ab ullam, numquam nesciunt in.
          </p>
          <div className={styles.socialIcons}>
            <img
              loading="lazy"
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/d6d9217da0fee077e45eb0e045758f10c02f42057229fb2cbad4ad027098b1d0?placeholderIfAbsent=true&apiKey=e6e279f9e06842139b3f7c01a7502bdc"
              alt="Facebook"
              className={styles.icon}
            />
            <img
              loading="lazy"
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/0b77b8fbc853301b02063dd187bd755b689d83f74da646c7fc75052c1fb8dfee?placeholderIfAbsent=true&apiKey=e6e279f9e06842139b3f7c01a7502bdc"
              alt="Instagram"
              className={styles.icon}
            />
            <img
              loading="lazy"
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/9941e7f91970a8bf18aecd9d27059d65a1e684489584ef9c506be58fa05143c1?placeholderIfAbsent=true&apiKey=e6e279f9e06842139b3f7c01a7502bdc"
              alt="Twitter"
              className={styles.icon}
            />
          </div>
        </div>
        <div className={styles.contactSection}>
          <h4>Gcash</h4>
          <p>123456789101112</p>
          
        </div>
        <div className={styles.qrCode}>QR</div>
      </div>
      <hr className={styles.footerDivider} />
      <p className={styles.copyright}>
        © 2024 | Gulmatico 2nd Hand Clothing Store | All Rights Reserved |
        Powered by [YourWebDevCompanyName].com
      </p>
    </footer>
  );
}

export default Footer;
